import { render, staticRenderFns } from "./CreateCampaignsTemplate.vue?vue&type=template&id=37798bc7&scoped=true&"
import script from "./CreateCampaignsTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateCampaignsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CreateCampaignsTemplate.vue?vue&type=style&index=0&id=37798bc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37798bc7",
  null
  
)

export default component.exports